<template>
    <div class="columns is-mobile size-row mb-1" v-bind:class="{'has-background-success':(sizeCompleted === true)}">
        <div class="column has-text-right">
            {{ size.name }}
        </div>
        <div class="column has-text-centered">
            <input type="tel" class="input is-small has-text-centered" v-model="originalQuantityOutstanding" ref="inputQty"/>
        </div>
        <div class="column">
            <button class="button is-small is-success" v-if="sizeCompleted!=true" @click="submitForm()" :disabled="working==true" >Complete</button>
        </div>
    </div>
</template>

<script>
export default 
{
    name: 'SizeRow',
 props: ['size', 'order', 'working', 'area'],
 data() {
     return {
         originalQty : this.order[this.size.database_name] + this.order[this.size.database_name + "_GK"],
        
         
     }
 },
 computed: {
     quantityCompleted: function() {
         let currentSizeId = this.size.id
         
         if(this.area == "paper")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.printing_papers.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId)
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

           //  if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
           // }

         }

         if(this.area == "rolls")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.printing_rolls.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId)
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

            //if(totalCompleted >= this.originalQty)
           // {
           //     return true
           return quantityCompleted
            //}

         }

         if(this.area == "cutting")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.cuttings.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId)
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

            //if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
            //}

         }

         if(this.area == "multiply_cutting")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.multiply_cuttings.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId)
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

            //if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
            //}

         }

         if(this.area == "cutsew_cutting")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.cutsew_cuttings.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId)
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

            //if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
            //}

         }

         if(this.area == "on_floor")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.makeup_logs.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId && currentValue.makeup_area=="on_floor")
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

            //if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
            //}

         }

         if(this.area == "off_floor")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.makeup_logs.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId && currentValue.makeup_area=="off_floor")
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

            //if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
            //}

         }

         if(this.area == "embroidery")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.makeup_logs.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId && currentValue.makeup_area=="embroidery")
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

            //if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
            //}

         }

         if(this.area == "silicon_stripes")
         {
             // Check the log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.order.makeup_logs.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId && currentValue.makeup_area=="silicon_stripes")
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

            //if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
            //}

         }

         return false
     },
     
     sizeCompleted: function() {
         return this.quantityCompleted >= this.originalQty
     },
      originalQuantityOutstanding : function() {
            return this.originalQty - this.quantityCompleted
     } ,
 },
 methods: {
     submitForm()
     {
         this.$emit('submitForm', this.$refs.inputQty.value)
     },
    
 }
}
</script>
